<script setup>
import lottie404 from "@/assets/lottie/404.json";
import { useAppState } from "@/composables/useAppState";
import { useMode } from "@/composables/useMode";

const { triggerError } = useAppState();
const { setIsSearchOpen } = useMode();

triggerError();
</script>

<template>
    <NuxtLayout>
        <section
            class="relative flex size-full flex-col overflow-hidden pt-[147px] sm:pt-[176px] lg:pt-[112px]"
        >
            <div
                class="absolute bottom-[23%] right-[-15vw] z-10 flex size-[80vw] translate-y-1/2 items-end justify-end sm:bottom-[24%] sm:right-[-13vw] sm:size-[64.97vw] md:bottom-[26%] md:right-[-11vw] md:size-[58vw] lg:bottom-[36%] lg:right-0 lg:size-[49.14vw] lg:max-h-[743px] lg:max-w-[743px] 3xl:left-[55%]"
            >
                <div
                    class="absolute bottom-0 right-0 z-20 hidden h-full w-[5%] bg-[linear-gradient(90deg,rgba(247,248,248,0)_0%,rgba(247,248,248,1)_100%)] lg:block"
                ></div>

                <ClientOnly>
                    <LottieAnimation
                        :animationData="lottie404"
                        :loop="false"
                        class="z-10 size-full"
                    />
                </ClientOnly>
            </div>
            <div
                class="z-20 mx-auto w-[91.85vw] max-w-[var(--slt-container-width-sm)] sm:w-[89.58vw] lg:w-[62.69vw]"
            >
                <h3
                    class="slt-h3 mb-2 px-1 font-bold text-primary-orange sm:mb-6 lg:mb-[30px]"
                >
                    404
                </h3>
                <h1 class="slt-h1 mb-8 px-1 sm:mb-10 lg:mb-14">
                    {{ $t("error.text") }}
                </h1>
                <div
                    class="mb-8 grid grid-cols-1 gap-3 sm:mb-10 sm:grid-cols-2 lg:mb-14 lg:flex"
                >
                    <BaseIconButton
                        variant="secondary"
                        :isLink="false"
                        :ariaLabel="$t('ariaLabel.error.search')"
                        @click="setIsSearchOpen(true) && triggerError()"
                    >
                        <template #svg
                            ><SvgSearch24
                                class="h-[6.1vw] w-[6.1vw] xs:h-6 xs:w-6"
                        /></template>
                        {{ $t("error.search") }}
                    </BaseIconButton>

                    <BaseIconButton
                        variant="primary"
                        :ariaLabel="$t('ariaLabel.error.goHome')"
                        :to="$localePath('/')"
                    >
                        <template #svg
                            ><SvgArrowBackAngle24
                                class="h-[6.1vw] w-[6.1vw] xs:h-6 xs:w-6"
                        /></template>
                        {{ $t("error.goHome") }}
                    </BaseIconButton>
                </div>
                <MoleculesFastLinks />
            </div>
        </section>
    </NuxtLayout>
</template>
